import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const signUpApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    signUp: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/signup',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
  overrideExisting: 'throw',
});
